// 公告弹窗逻辑层
import { useRoute } from "vue-router";
import { delay } from "@/utils/delay";
import { useAppStore } from "@/store/app";
import { ref, computed, watch } from 'vue';
import { useUserStore } from "@/store/user";
import { useStatusStore } from "@/store/status";
import { useTenantStore } from '@/store/tenant';
import { useChannelStore } from '@/store/channel';
import { AnnouncementLoginInModel } from "@/api/personal/model";
import useLinkHandle from "@/hooks/useLinkHandle";
import { showLogin } from '@/hooks/ShowLogin'

export default function useLogic() {
  const route = useRoute();               // 路由
  const appStore = useAppStore();         // 用户store
  const userStore = useUserStore();       // 用户store
  const tenantStore = useTenantStore();   // 租户store
  const statusStore = useStatusStore();   // 状态store
  const channelStore = useChannelStore(); // 渠道store

  const announcementLink = ref('');                                               // 链接
  const announcementDetail = ref('');                                             // 公告详情
  const announcementType = ref('text');                                           // 类型
  const announceBgImg = ref('');                                                  // 公告背景图片
  const announcementLinkType = ref<AnnouncementLoginInModel[0]['type']>();        // 链接跳转类型
  const announcementValueType = ref<AnnouncementLoginInModel[0]['valueType']>();  // 链接格式类型

  const announcementList = computed(() => tenantStore.announcementList);        // 公告列表
  const announcementVisible = computed(() => tenantStore.announcementVisible);  // 公告是否显示
  const todayInvisible = computed(() => statusStore.announcementInvisible);     // 今日不再显示

  // 监听公告列表长度变化
  watch(
    [
      () => announcementList.value.length,  // 公告列表长度
      () => channelStore.modalChecked,      // 安装弹窗检测状态
      () => appStore.modalVisible,          // 弹窗是否显示
      () => appStore.pwaFooterVisible,      // pwa底部是否显示
    ],
    async () => {
      await delay(300);
    if (announcementList.value.length > 0 && channelStore.modalChecked && !appStore.modalVisible && (appStore.pwaFooterVisible !==1 || userStore.isAppUser)) {
      await getAnnouncementDetail();
    }
  });

  // 监听路由变化
  watch(() => route.path, () => {
    if (route.path !== '/main/inicio') {
      tenantStore.setAnnouncementVisible(false);
      announcementDetail.value = '';
      tenantStore.clearAnnouncementList();
    }
  });

  /**
   * @description 关闭弹窗
   */
  function dismiss() {
    const announcement = announcementList.value[0];
    if (todayInvisible.value || announcement.popupMethod === 'day' || announcement.popupMethod === 'one') {
      tenantStore.setAnnouncementHide(announcement.id);
    } else if (announcement.popupMethod === 'login') {
      tenantStore.setAnnouncementInvisible(announcement.id);
    }
    tenantStore.setAnnouncementVisible(false);
    announcementDetail.value = '';
    setTimeout(() => {
      tenantStore.shiftAnnouncementList();
    }, 300);
  }

  /**
   * @description 获取公告详情
   */
  async function getAnnouncementDetail() {
    const announcement = announcementList.value[0];
    announcementType.value = announcement.announcementType;
    announcementLink.value = announcement.value;
    announcementLinkType.value = announcement.type;
    announcementValueType.value = announcement.valueType;
    announcementDetail.value = '';
    tenantStore.setAnnouncementVisible();
    announceBgImg.value = announcement.imgUrl;
    if (announcementType.value === 'text') {
      announcementType.value = 'text';
      const response = await fetch(announcement.content);
      announcementDetail.value = await response.text();
      announceBgImg.value = announcement.imgUrl;
    }
    else {
      announcementDetail.value = announcement.imgUrl;
    }
  }

  /**
   * @description 公告链接跳转
   */
  function onLinkHandle() {
  if (announcementLink.value && announcementLink.value == '/register') {
    if (!appStore.token) {
      dismiss()
      showLogin('register')
    }
  } else{
    useLinkHandle(announcementLinkType.value, announcementLink.value, announcementValueType.value)
  }
  }

  /**
   * @description 今日不再提醒文本点击事件
   */
  function checkHandle() {
    if (todayInvisible.value) {
      statusStore.setAnnouncementInvisible(false);
    } else {
      statusStore.setAnnouncementInvisible(true);
    }
  }

  return {
    announcementList,
    announcementVisible,
    announcementDetail,
    announcementType,
    todayInvisible,
    announceBgImg,
    dismiss,
    onLinkHandle,
    checkHandle
  }
}
